
import { Tooltip } from "react-tooltip";
import SecurityActionsDropdown from "./SecurityActionsDropdown";
import { PropTypes } from 'prop-types';

const SecurityRowAdvanced = ({
  security,
  role,
  onViewDetails,
  onEditPrice,
  onViewHolders,
  onGenerateReport,
  onViewPriceHistory,
  onCreateTransaction,
  onGenerateDocuments,
  onViewTransactionDetails,
  onViewStatistics,
  onDeleteSecurity
}) => {
  const isPublic = security.targetMarket === 'Public';
  const isPrivate = security.targetMarket === 'Private';
  const isMonetary = security.targetMarket === 'Monetary';

  const getMarketBadge = (market) => {
    const badges = {
      'Public': 'bg-success bg-opacity-10 text-success border border-success border-opacity-25',
      'Private': 'primary bg-opacity-10 text-primary bg-light border border-primary border-opacity-25',
      'Monetary': 'bg-info bg-opacity-10 text-info border border-info border-opacity-25'
    };
    return badges[market] || 'bg-secondary bg-opacity-10 text-secondary';
  };

  const formatNumber = (num) => {
    if (num === null || num === undefined) return '-';
    return new Intl.NumberFormat('fr-FR').format(num);
  };

  const formatCurrency = (amount) => {
    if (amount === null || amount === undefined) return '-';
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'XAF',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  };

  // Détenteurs pour Public et Private
  const getHoldersCount = () => {
    if (isPublic) {
      return security.totalHolders?.numberOfHolders || 0;
    } else if (isPrivate) {
      return security.totalHolders?.numberOfHolders || 0;
    }
    return 0;
  };

  const getTotalQuantity = () => {
    if (isPublic) {
      return security.totalHolders?.totalQuantity || 0;
    } else if (isPrivate) {
      return security.totalHolders?.totalQuantity || 0;
    }
    return 0;
  };

  return (
    <tr className="border-bottom align-middle hover-row">

       <td>
        <div className="d-flex align-items-center">
          <div className={`avatar-sm rounded-pill me-3 ${isPublic ? 'bg-success bg-opacity-10' : isPrivate ? 'bg-primary-soft' : 'bg-info bg-opacity-10'}`}>
            <span className="avatar-title fw-bold">
              {security.isin?.charAt(0)?.toUpperCase() || 'T'}
            </span>
          </div>
          <div>
            <h6 className="mb-0 fw-semibold">{security.isin}</h6>
          </div>
        </div>
      </td>
      {/* Nom du titre */}
      <td>
        <div className="d-flex align-items-center">
          <div>
            <h6 className="mb-0 fw-semibold">{security.securityName}</h6>
          </div>
        </div>
      </td>

      {/* Émetteur */}
      <td>
        <div>
          <div className="fw-medium">{security.issuerName}</div>
          {/* <small className="text-muted">{security.issuerType}</small> */}
        </div>
      </td>

      {/* Type et marché */}
      <td>
        <div className="d-flex flex-column gap-1">
          <span className="badge bg-light text-dark border border-opacity-25 bg-opacity-10">
            {security.securityType === 'Shares' ? 'Actions' : security.securityType === 'Bonds' ? 'Obligations' : security.securityType}
          </span>
        </div>
      </td>

      <td>
        <span className={`badge ${getMarketBadge(security.targetMarket)}`}>
          {security.targetMarket === 'Private' ? 'Non Cote' : security.targetMarket === 'Public' ? 'Cote' : security.targetMarket === 'Monetary' ? 'Monétaire' : security.targetMarket}
        </span>
      </td>

      {/* coupon_rate */}
      <td>
        <span 
          className="badge bg-success bg-opacity-10 text-success fw-semibold"
          data-tooltip-id={`holders-tooltip-${security.securityId}`}
        >
          {security.couponRate ? `${security.couponRate}%` : '-'}
        </span>
        {/* <Tooltip id={`quantity-tooltip-${security.securityId}`} place="top">
          Coupon : {security.couponRate ? `${security.couponRate}%` : 'N/A'}
        </Tooltip> */}
      </td>

      {/* Statistiques pour Public et Private */}
      {(isPublic || isPrivate) && (
        <>
          <td className="text-center">
            <span 
              className="badge bg-warning bg-opacity-10 text-warning fw-semibold"
              data-tooltip-id={`holders-tooltip-${security.securityId}`}
            >
              {formatNumber(getHoldersCount())}
            </span>
            <Tooltip id={`holders-tooltip-${security.securityId}`} place="top">
              {isPublic ? 'Porteurs' : 'Nominatifs'} : {getHoldersCount()} détenteur(s)
            </Tooltip>
          </td>
          <td className="text-center">
            <span 
              className="badge bg-info bg-opacity-10 text-info fw-semibold"
              data-tooltip-id={`quantity-tooltip-${security.securityId}`}
            >
              {formatNumber(getTotalQuantity())}
            </span>
            <Tooltip id={`quantity-tooltip-${security.securityId}`} place="top">
              Quantité totale : {formatNumber(getTotalQuantity())}
            </Tooltip>
          </td>
        </>
      )}

      {/* Dernier prix */}
      <td className="text-end fw-semibold">
        {formatCurrency(security.lastPrice)}
      </td>

      {/* Actions */}
      {/* Actions */}
    <td className="text-center">
      <SecurityActionsDropdown
        security={security}
        role={role}

        onViewDetails={onViewDetails}
        onEditPrice={onEditPrice}
        onViewHolders={onViewHolders}
        onGenerateReport={onGenerateReport}

        onCreateTransaction={onCreateTransaction}
        onGenerateDocuments={onGenerateDocuments}
        onViewTransactionDetails={onViewTransactionDetails}
        onViewStatistics={onViewStatistics} 
        onDeleteSecurity={onDeleteSecurity} 
      />
    </td>

    </tr>
  );
};

SecurityRowAdvanced.propTypes = {
  // ... autres PropTypes ...
  onViewStatistics: PropTypes.func,
  onDeleteSecurity: PropTypes.func
};
export default SecurityRowAdvanced;